import PdfImage from 'assets/images/onepager-pdf-img.svg';
import { Close as CloseIcon } from '@mui/icons-material';
import { useForm } from 'react-hook-form';
import { makeStyles } from '@mui/styles';
import { CircularProgress, FormGroup, Modal, useTheme } from '@mui/material';
import { CustomButton, CustomTextField } from 'components/common';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

interface OnePagerCommonModalProps {
  openEnterEmailModal: boolean;
  emailSubmitHandler: (data?: { email: string } | undefined) => Promise<void>;
  openEnterEmailModalClose: () => void;
  loader?: boolean;
  downloadPdfLoading?: boolean;
  submitEmail?: { email: string };
  openModalOfOnePager?: boolean;
}

export default function OnePagerCommonModal({
  openEnterEmailModal,
  emailSubmitHandler,
  openEnterEmailModalClose,
  loader,
  downloadPdfLoading,
  submitEmail,
  openModalOfOnePager,
}: OnePagerCommonModalProps) {
  const theme = useTheme();
  const useStyles = makeStyles({
    CustomModal: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'rgb(229,229,229,0.5)',
    },
    modal: {
      maxWidth: '400px',
      outline: 'none',
      width: '90%',
      backgroundColor: '#fff',
      borderRadius: '20px',
    },
    modalHeader: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'flex-end',
      paddingBottom: '8px',
      padding: '20px 15px 30px 28px',

      '& img': {
        cursor: 'pointer',
      },
      '& svg': {
        cursor: 'pointer',
      },
    },
    modalBody: {
      padding: '0px 36px 0px 37px',
    },
    bannerImg: {
      width: 80,
      height: 90,
      display: 'block',
      margin: '0px 0px 38px 7px',
      '& img': {
        width: '100%',
      },
    },
    emailSection: {
      display: 'block',

      '& .MuiFormGroup-root': {
        '& .MuiFormControl-root': {
          height: '75px',
          '& .MuiInputBase-root': {
            '& fieldset': {
              borderColor: '#DFDFDF',
            },
          },
          '& .MuiFormLabel-root': {
            color: 'rgba(0, 0, 0, 0.5)',
            '&.MuiFormLabel-shrink': {
              transform: 'translate(14px, -8px) scale(1)',
            },
          },
        },
      },
      '& h6': {
        fontWeight: 500,
        fontSize: 18,
        lineHeight: '28px',
        color: '#111111',
        marginBottom: '18px',
        marginTop: '25px',
        [theme.breakpoints.down(321)]: {
          fontSize: 14,
          margin: '15px 0px 15px',
        },
      },
      '& h5': {
        fontWeight: 'normal',
        fontSize: 12,
        lineHeight: '28px',
        color: ' rgba(17, 17, 17, 0.5)',
        marginBottom: '34px',
        [theme.breakpoints.down(321)]: {
          marginBottom: '15px',
          lineHeight: 1,
        },
      },
      '& button': {
        display: 'flex',
        flexWrap: 'wrap',
        margin: '0px auto 53px',
        // padding: "20px 35px",
        minWidth: '250px',

        [theme.breakpoints.down(321)]: {
          margin: '0px auto 20px',
          padding: '20px',
          minWidth: '211px',
        },

        '& span': {
          fontSize: 20,
          [theme.breakpoints.down(321)]: {
            fontSize: '14px',
            lineHeight: 1,
          },
        },
      },
    },
    downloadPageSection: {
      display: 'block',
      marginBottom: '50px',
      '& h6': {
        fontWeight: 'normal',
        fontSize: 18,
        lineHeight: '26px',
        color: '#111111',
        margin: [[25, 0, 25, 0]],
        [theme.breakpoints.down(321)]: {
          fontSize: 14,
          margin: '15px 0px 15px',
        },
      },
      '& h5': {
        fontWeight: 500,
        fontSize: 16,
        lineHeight: '28px',
        textAlign: 'center',
        color: '#111111',
        marginBottom: '10px',
      },
      '& button': {
        display: 'flex',
        flexWrap: 'wrap',
        margin: '0px auto 0px',
        minWidth: '250px',
        padding: '20px 35px',

        [theme.breakpoints.down(321)]: {
          padding: '20px',
          minWidth: '211px',
        },

        '& span': {
          fontSize: 20,
          lineHeight: '23px',
          [theme.breakpoints.down(321)]: {
            fontSize: '14px',
            lineHeight: 1,
          },
        },
      },
    },
    error: {
      fontSize: 12,
      lineHeight: 1,
      display: 'flex',
      flexWrap: 'wrap',
      marginTop: '-5px',
      marginBottom: '6px',

      '& svg': {
        fontSize: 14,
        verticalAlign: 'middle',
        marginRight: 4,
      },
    },
    submitButton: {
      backgroundColor: '#008B5E',
      minWidth: '250px',
      height: '60px',
      border: '1px solid #008B5E',
      fontSize: '18px',
      color: '#fff',
      borderRadius: '100px',
      // padding: "23px 52px"
    },
  });
  const classes = useStyles();

  const schma = yup.object().shape({
    email: yup
      .string()
      .required('Email is required')
      .email('Please enter valid email address'),
  });
  const { handleSubmit, control } = useForm({
    mode: 'all',
    resolver: yupResolver(schma),
    defaultValues: { email: '' },
  });

  const onSubmit = (data: { email: string }) => {
    emailSubmitHandler(data);
  };

  const handleDownloadPdf = () => {
    emailSubmitHandler();
  };

  return (
    <>
      <Modal
        className={classes.CustomModal}
        open={openEnterEmailModal}
        closeAfterTransition
      >
        <div className={classes.modal}>
          <div className={classes.modalHeader}>
            <CloseIcon
              // className={classes.closeIcon}
              width={24}
              height={24}
              onClick={openEnterEmailModalClose}
            />
          </div>
          <div className={classes.modalBody}>
            <div className={classes.bannerImg}>
              <img src={PdfImage.src} alt="" />
            </div>
            {openModalOfOnePager ? (
              <>
                <div className={classes.emailSection}>
                  <h6>
                    Enter your Email ID where we can send you the One Pager PDF
                  </h6>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <FormGroup>
                      <CustomTextField
                        fullWidth
                        name="email"
                        label="Email"
                        type="text"
                        variant="outlined"
                        placeholder="Email"
                        control={control}
                      />
                    </FormGroup>
                    {/* <h5>Verification link will be sent to this email ID</h5> */}
                    {loader ? (
                      <>
                        <CustomButton className={classes.submitButton}>
                          <CircularProgress color="inherit" size={16} />
                        </CustomButton>
                      </>
                    ) : (
                      <CustomButton
                        className={classes.submitButton}
                        type="submit"
                      >
                        Send One Pager
                      </CustomButton>
                    )}
                  </form>
                </div>
              </>
            ) : (
              <div className={classes.downloadPageSection}>
                <h6>
                  One Pager PDF has been sent to your email ID{' '}
                  {submitEmail?.email}
                </h6>
                <h5>You can also download it here</h5>
                {downloadPdfLoading ? (
                  <>
                    <CustomButton className={classes.submitButton}>
                      <CircularProgress color="inherit" size={16} />
                    </CustomButton>
                  </>
                ) : (
                  <CustomButton
                    className={classes.submitButton}
                    type="submit"
                    onClick={handleDownloadPdf}
                  >
                    <span>
                      Download for Free <del>Rs.99</del>
                    </span>
                  </CustomButton>
                )}
              </div>
            )}
          </div>
        </div>
      </Modal>
    </>
  );
}
